<template>
	<div class="page">
		<div class="practice-map">
			<div class="p-top">
				<div class="p-left" @click="backHome">
					<img :src="require('@/assets/img/common/back_home@2x.png')" alt="" class="p-image-home" />
					<div class="p-backtips">返回首页</div>
				</div>
				<div class="p-arrow-tips">></div>
				<div class="p-map-tips" @click="goMap">实践地图</div>
			</div>

			<div class="map">
				<div class="map-left">
					<div class="map-left-item">
						<img src="../assets/img/map/map-left-1.png" alt="" />
						<p class="map-left-item-number">{{ statisticsNum.deptcount }}</p>
						<p class="map-left-item-text">志愿组织数</p>
					</div>
					<div class="map-left-item">
						<img src="../assets/img/map/map-left-2.png" alt="" />
						<p class="map-left-item-number">{{ summaryData.person }}</p>
						<p class="map-left-item-text">志愿者人数</p>
					</div>
					<div class="map-left-item">
						<img src="../assets/img/map/map-left-3.png" alt="" />
						<p class="map-left-item-number">{{ totalDevelopActivityNum }}</p>
						<p class="map-left-item-text">志愿活动数</p>
					</div>
					<div class="map-left-item">
						<img src="../assets/img/map/map-left-4.png" alt="" />
						<p class="map-left-item-number">{{ summaryDataTime }}</p>
						<p class="map-left-item-text">志愿时长数</p>
					</div>
				</div>
				<div class="map-right">
					<div class="map-right-top">
						<!-- <div class="map-right-top-item">
							<img src="../assets/img/map/map-right-1.png" alt="" />

							<p>{{ practiceStationData.subStationNum }}</p>
						</div> -->
						<div class="map-right-top-item">
							<img src="../assets/img/map/map-right-2.png" alt="" />

							<p>{{ practiceStationData.practiceCenterNum }}</p>
						</div>
						<div class="map-right-top-item">
							<img src="../assets/img/map/map-right-3.png" alt="" />

							<p>{{ practiceStationData.stationNum }}</p>
						</div>
						<div class="map-right-top-item">
							<img src="../assets/img/map/map-right-4.png" alt="" />

							<p>{{ practiceStationData.subPointNum }}</p>
						</div>
					</div>
					<div class="map-right-bottom">
						<div class="map-right-bottom-map" v-if="currentKey == -1">
							<img :src="mapList[0].image" class="p-map lingshi" alt="" @click="jumpMap(0)" />
							<img :src="mapList[1].image" class="p-map jiexiu" alt="" @click="jumpMap(1)" />
							<img :src="mapList[2].image" class="p-map pingyao" alt="" @click="jumpMap(2)" />
							<img :src="mapList[3].image" class="p-map qixian" alt="" @click="jumpMap(3)" />
							<img :src="mapList[4].image" class="p-map yushe" alt="" @click="jumpMap(4)" />
							<img :src="mapList[5].image" class="p-map zuoquan" alt="" @click="jumpMap(5)" />
							<img :src="mapList[6].image" class="p-map taigu" alt="" @click="jumpMap(6)" />
							<img :src="mapList[7].image" class="p-map yuci" alt="" @click="jumpMap(7)" />
							<img :src="mapList[8].image" class="p-map shouyang" alt="" @click="jumpMap(8)" />
							<img :src="mapList[9].image" class="p-map xiyang" alt="" @click="jumpMap(9)" />
							<img :src="mapList[10].image" class="p-map heshun" alt="" @click="jumpMap(10)" />

							<img src="../assets/img/map/map-total.png" class="total-image" alt="" />
						</div>
						<div v-else class="map-large-box">
							<img :src="mapList[currentKey].image" class="" alt="" />
							<div class="map-large-content">
								<div class="map-large-content-box">
									<img src="../assets/img/map/map_arrow.png" alt="" class="map-large-arrow" />
									<img src="../assets/img/map/map_star.png" alt="" class="map-large-star" />
									<div class="map-large-title">{{ mapList[currentKey].name }}新时代文明实践中心</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			// 志愿者组织数
			statisticsNum: {},
			// 志愿活动数
			totalDevelopActivityNum: '0',
			// 志愿者人数
			summaryData: {},
			summaryDataTime: {},
			practiceStationData: {},
			currentKey: -1,
			mapList: [
				{
					image: require('@/assets/img/map/lingshi.png'),
					name: '灵石县',
					deptId: '14760841123594f3a08eba11e682992c56dcba85b9'
				},
				{
					image: require('@/assets/img/map/jiexiu.png'),
					name: '介休市',
					deptId: '14760841123594f4918eba11e682992c56dcba85b9'
				},
				{
					image: require('@/assets/img/map/pingyao.png'),
					name: '平遥县',
					deptId: '14760841123594f2808eba11e682992c56dcba85b9'
				},
				{
					image: require('@/assets/img/map/qixian.png'),
					name: '祁县',
					deptId: '14760841123594eca88eba11e682992c56dcba85b9'
				},
				{
					image: require('@/assets/img/map/yushe.png'),
					name: '榆社县',
					deptId: '14760841123594d8888eba11e682992c56dcba85b9'
				},
				{
					image: require('@/assets/img/map/zuoquan.png'),
					name: '左权县',
					deptId: '14760841123594da8d8eba11e682992c56dcba85b9'
				},
				{
					image: require('@/assets/img/map/taigu.png'),
					name: '太谷区',
					deptId: '14760841123594ea1d8eba11e682992c56dcba85b9'
				},
				{
					image: require('@/assets/img/map/yuci.png'),
					name: '榆次区',
					deptId: '14760841123594d6448eba11e682992c56dcba85b9'
				},
				{
					image: require('@/assets/img/map/shouyang.png'),
					name: '寿阳县',
					deptId: '14760841123594e1038eba11e682992c56dcba85b9'
				},
				{
					image: require('@/assets/img/map/xiyang.png'),
					name: '昔阳县',
					deptId: '14760841123594defe8eba11e682992c56dcba85b9'
				},
				{
					image: require('@/assets/img/map/heshun.png'),
					name: '和顺县',
					deptId: '14760841123594dcba8eba11e682992c56dcba85b9'
				}
			]
		}
	},
	created() {
		console.log(this.$route)
		if (this.$route.params.index) {
			this.currentKey = Number(this.$route.params.index)
			let e = this.mapList[this.currentKey].deptId
			this.getLeftFirst(e)
			this.getLeftActivityNum(e)
			this.getDeptSummaryData(e)
		}
	},
	mounted() {
		// this.getLeftFirst()
		// this.getLeftActivityNum()
		this.getTop()
		// this.getDeptSummaryData()
		const _this = this
		this.$EventBus.$on('mapChange', (index) => {
			_this.currentKey = Number(index)
			console.log('value', _this.currentKey)
			let e = _this.mapList[_this.currentKey].deptId
			_this.getLeftFirst(e)
			_this.getLeftActivityNum(e)
			_this.getDeptSummaryData(e)
		})
	},
	methods: {
		getLeftFirst(e) {
			// this.$api.vmsapi.statisticsNumList({ deptId: process.env.VUE_APP_deptId }).then((res) => {
			// 	console.log('statisticsNum', res)
			// 	this.statisticsNum = res.data
			this.$api.vmsapi.zyzOrgNumList({ deptid: e }).then((res) => {
				this.statisticsNum = res
			})
		},
		// 获取志愿活动数
		getLeftActivityNum(e) {
			this.$api.vmsapi.totalDevelopActivityNum({ deptId: e }).then((res) => {
				console.log('totalDevelopActivityNum', res)
				this.totalDevelopActivityNum = res
			})
		},
		// 获取志愿者人数
		getDeptSummaryData(e) {
			this.$api.vmsapi.summaryData({ deptId: e }).then((res) => {
				console.log('summaryData', res)
				this.summaryData = res
				this.summaryDataTime = res.value.toFixed(2)
			})
		},
		getTop() {
			this.$api.xsdapi
				.practiceStation({ practiceCenterId: '16370560657342a4d53f7ac77447280c90a79b30a4652' })
				.then((res) => {
					this.practiceStationData = res
				})
		},
		jumpMap(value) {
			this.currentKey = value
		},
		backHome() {
			this.$router.replace({ path: '/' })
			this.$EventBus.$emit('showPath', 'home')
		},
		goMap() {
			this.currentKey = -1
		}
	}
}
</script>
<style lang="scss" scoped>
.page {
	width: 100%;
	height: 100%;
	background-color: #fff;
	padding-top: 23px;
	padding-bottom: 100px;
}
.practice-map {
	width: 1200px;
	position: relative;
	margin: 0 auto;
}
.p-top {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	font-size: 16px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	line-height: 16px;
	margin-bottom: 57px;
	.p-left {
		cursor: pointer;
		display: flex;
		align-items: center;
		font-size: 16px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #222222;
		line-height: 16px;
		.p-image-home {
			width: 26px;
			height: 26px;
			margin-right: 6px;
		}
	}
	.p-arrow-tips {
		margin: 0 5px;
	}
	.p-map-tips {
		cursor: pointer;
		color: #cd3232;
	}
}
.map {
	display: flex;
	flex-direction: row;
	.map-left {
		display: grid;
		grid-template-columns: 251px;
		grid-template-rows: 182px 182px 182px 182px;
		z-index: 1;
		.map-left-item {
			position: relative;

			img {
				position: absolute;
				z-index: -1;
			}
			.map-left-item-number {
				position: absolute;
				z-index: 1;
				left: 23px;
				top: 40px;
				font-size: 36px;
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 600;
				color: #ffffff;
				line-height: 50px;
			}
			.map-left-item-text {
				position: absolute;
				z-index: 1;
				left: 23px;
				top: 92px;
				font-size: 20px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #ffffff;
				line-height: 28px;
			}
		}
	}
	.map-right {
		margin-left: 11px;
		z-index: 1;
		.map-right-top {
			display: grid;
			grid-template-columns: 238px 238px 238px 238px;
			grid-template-rows: 90px;
			.map-right-top-item {
				position: relative;
				margin-right: 11px;
				img {
					position: absolute;
					z-index: -1;
				}
				p {
					position: absolute;
					right: 48px;
					top: 20px;
					font-size: 36px;
					font-family: PingFangSC-Semibold, PingFang SC;
					font-weight: 600;
					color: #ffffff;
					line-height: 50px;
				}
			}
		}
		.map-right-bottom {
			margin-top: 90px;
			.map-right-bottom-map {
				position: relative;
				.total-image {
					width: 911px;
					height: 501px;
					pointer-events: none;
					z-index: 1;
					margin-left: 8px;
				}
				.p-map {
					position: absolute;
					opacity: 0;
					cursor: pointer;
				}
				.lingshi {
					left: 30px;
					bottom: 20px;
					width: 150px;
					z-index: 2;
				}
				.jiexiu {
					z-index: 3;
					bottom: 90px;
					width: 100px;
					left: 140px;
				}
				.pingyao {
					z-index: 4;
					bottom: 150px;
					width: 100px;
					left: 220px;
				}
				.qixian {
					z-index: 5;
					bottom: 210px;
					width: 60px;
					left: 300px;
				}
				.yushe {
					z-index: 6;
					bottom: 150px;
					width: 80px;
					left: 460px;
				}
				.zuoquan {
					z-index: 7;
					bottom: 115px;
					width: 100px;
					right: 230px;
				}
				.taigu {
					z-index: 8;
					bottom: 240px;
					width: 90px;
					left: 400px;
				}
				.yuci {
					z-index: 9;
					left: 400px;
					width: 90px;
					top: 100px;
				}
				.shouyang {
					z-index: 10;
					top: 30px;
					width: 120px;
					left: 500px;
				}
				.xiyang {
					z-index: 11;
					right: 100px;
					width: 120px;
					top: 150px;
				}
				.heshun {
					z-index: 12;
					right: 200px;
					width: 120px;
					top: 220px;
				}
			}
			.map-large-box {
				position: relative;
				display: flex;
				justify-content: center;
				.map-large-content {
					position: absolute;
					.map-large-content-box {
						position: relative;
						width: 300px;
						height: 110px;
						.map-large-arrow {
							position: absolute;
						}
						.map-large-star {
							position: absolute;
							bottom: 0;
							left: 128px;
						}
						.map-large-title {
							position: absolute;
							left: 0;
							right: 0;
							top: 38px;
							font-size: 14px;
							font-family: PingFangSC-Regular, PingFang SC;
							font-weight: 400;
							color: #ff8d02;
							line-height: 25px;
						}
					}
				}
			}
		}
	}
}
</style>
